import React from 'react'
// import { useSelector } from 'react-redux'
// import { Link } from 'react-router-dom'
import {
  Form, FormGroup, Input
} from 'reactstrap'
import PropTypes from 'prop-types'
// import excelIcon from '../../../assests/images/excel-icon.svg'
// import addlIcon from '../../../assests/images/add-white-icon.svg'
// import calendarIcon from '../../../assests/images/calendar-icon.svg'
// import constants from '../../../constants'

function ContestHeader ({
  header,
  handleSearch,
  search,
  onContestFilter,
  contestFilter,
  filter,
  handleExport,
  handleKeyPress,
  startDate,
  endDate,
  handleDateRangePicker
}) {
  // const eKey = header === 'UC' ? 'USERCONTEST' : header === 'C' ? 'CONTEST' : 'WINNING_PATTERN'
  // const adminData = useSelector(state => state.auth.adminData)
  // const permission = (!!adminData?.aPermissions?.length && adminData.aPermissions.find(e => e.eKey === eKey)?.eType) ? adminData.aPermissions.find(e => e.eKey === eKey).eType : adminData.eType === 'SUPER' ? constants.WRITE_PERMISSION : constants.NO_PERMISSION

  // const btnText = (header === 'UC') ? 'User Contest' : 'Contest'

  return (
    <div className="header-block">
      <h2>{header === 'UC' ? 'User Contest Management' : header === 'WP' ? 'Winning Pattern Management' : 'Contest Management'}</h2>
      {filter &&
        (
          <div className="filter-block d-flex justify-content-between align-items-start">
            <Form className="d-flex">
              <FormGroup>
                <Input type="text" className="search-box" name="search" placeholder="Search" id={search} value={search} onKeyPress={handleKeyPress} onChange={handleSearch} />
              </FormGroup>

              {/* {header === 'UC'
                ? (
                <FormGroup>
                  <CustomInput type="select" name="contestFilter" id="userContestFilterStatus" placeholder="Contest type" className="form-control" value={contestFilter.status} onChange={e => onContestFilter(e, 'status')}>
                    <option value="">Contest Status(All)</option>
                    <option value="P">Pending</option>
                    <option value="U">Upcoming</option>
                    <option value="L">Live</option>
                    <option value="CMP">Completed</option>
                    <option value="CNCL">Cancel</option>
                  </CustomInput>
                </FormGroup>
                  )
                : (
                <FormGroup>
                  <CustomInput type="select" name="contestFilter" id="contestFilterStatus" placeholder="Contest type" className="form-control" value={contestFilter.status} onChange={e => onContestFilter(e, 'status')} >
                    <option value="">Contest Status(All)</option>
                    <option value="Y">Active</option>
                    <option value="N">Inactive</option>
                  </CustomInput>
                </FormGroup>
                  )} */}
              {/* <FormGroup>
                <CustomInput type="select" id="contestFilterType" name="contestFilter" placeholder="Contest type" className="form-control" value={contestFilter.type} onChange={e => onContestFilter(e, 'type')}>
                  <option value="">Contest Type(All)</option>
                  <option value="TB">Time based</option>
                  {header === 'UC' && <option value="PC">Private Contests</option>}
                </CustomInput>
              </FormGroup> */}
              {/* <FormGroup>
                <Button className="form-control date-range" name="date-range" onClick={handleDateRangePicker}>
                  {startDate && endDate ? `${startDate} - ${endDate}` : 'Select Date Range'}
                  {' '}
                  <img src={calendarIcon} alt="calendar" />
                </Button>
              </FormGroup> */}

            </Form>
            <div className="btn-list">
              {/* <Button onClick={handleExport} className="theme-btn outline-btn outline-success icon-btn">
                <img src={excelIcon} alt="excel" />
                Export
              </Button> */}
              {/* {(permission === constants.WRITE_PERMISSION) && (
                <Button tag={Link} to={header === 'UC' ? '/contest/add-user-contest' : '/contest/add-contest'} className="theme-btn icon-btn">
                  <img src={addlIcon} alt="add" />
                  {`Add ${btnText}`}
                </Button>
              )} */}
            </div>
          </div>
        )}
    </div>
  )
}

ContestHeader.defaultProps = {
  filter: false
}

ContestHeader.propTypes = {
  handleSearch: PropTypes.func,
  onExport: PropTypes.func,
  search: PropTypes.string,
  header: PropTypes.string.isRequired,
  filter: PropTypes.bool,
  addButton: PropTypes.string,
  contestFilter: PropTypes.object,
  handleDateRangePicker: PropTypes.func,
  onContestFilter: PropTypes.func,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  handleExport: PropTypes.func,
  handleKeyPress: PropTypes.func

}

export default ContestHeader
